// routes/config/playerRoutes.ts
/**
 * Player Portal Route Configuration
 * Routes for registered players with full accounts
 */

import { lazy } from 'react';
import { ROUTES } from '../../config/routes';
import type { RouteConfig } from '../types';

const PlayerRegistrationPage = lazy(() => import('../../features/player-portal/pages/PlayerRegistrationPage'));
const PlayerDashboardPage = lazy(() => import('../../features/player-portal/pages/PlayerDashboardPage'));
const PlayerTournamentPage = lazy(() => import('../../features/player-portal/pages/PlayerTournamentPage'));
const PlayerSettingsPage = lazy(() => import('../../features/player-portal/pages/PlayerSettingsPage'));
const PlayerFeedbackPage = lazy(() => import('../../features/player-portal/pages/PlayerFeedbackPage'));
const ParentDashboardPage = lazy(() => import('../../features/parent/pages/ParentDashboardPage'));
const PlayerDecksPage = lazy(() => import('../../features/deck-builder/pages/PlayerDecksPage'));
const DeckBuilderPage = lazy(() => import('../../features/deck-builder/pages/DeckBuilderPage'));

export const playerRoutes: RouteConfig[] = [
  {
    path: ROUTES.PLAYER_REGISTER,
    element: PlayerRegistrationPage,
    auth: 'playerPublic', // Redirect if player already logged in
  },
  {
    // Entry-point: a logged-in user with no staff/player picker
    // preference gets bounced to /welcome before the player
    // dashboard renders. Sub-routes like /player/decks are not
    // gated this way so deep links keep working.
    path: ROUTES.PLAYER_DASHBOARD,
    element: PlayerDashboardPage,
    auth: 'player',
    entryRedirect: true,
  },
  {
    path: ROUTES.PLAYER_TOURNAMENT,
    element: PlayerTournamentPage,
    auth: 'player',
  },
  {
    path: ROUTES.PLAYER_SETTINGS,
    element: PlayerSettingsPage,
    auth: 'player',
  },
  {
    path: ROUTES.PLAYER_FEEDBACK,
    element: PlayerFeedbackPage,
    auth: 'player',
  },
  {
    path: ROUTES.PARENT_DASHBOARD,
    element: ParentDashboardPage,
    auth: 'player',
  },
  {
    path: ROUTES.PLAYER_DECKS,
    element: PlayerDecksPage,
    auth: 'player',
  },
  {
    path: ROUTES.PLAYER_DECK_NEW,
    element: DeckBuilderPage,
    auth: 'player',
  },
  {
    path: ROUTES.PLAYER_DECK_EDIT,
    element: DeckBuilderPage,
    auth: 'player',
  },
];
